import { useState } from "react";
import { VIDEO_ASPECTS } from "../store/Store";

export default function VideoProductCard({ video, product, onNav, width }) {
  const [muted, setMuted] = useState(true);
  const aspect = VIDEO_ASPECTS.find(a=>a.key===video.aspectRatio) || VIDEO_ASPECTS[0];
  const isBanner = aspect.key === "banner";

  return (
    <div style={{
      width: isBanner ? "100%" : (width || "clamp(170px,22vw,220px)"),
      flexShrink: isBanner ? undefined : 0,
      cursor: product ? "pointer" : "default",
      background:"white",
      borderRadius:18,
      overflow:"hidden",
      border:"1px solid #f0f0f0",
      boxShadow:"0 2px 12px rgba(0,0,0,0.05)",
    }}
      onClick={()=>product && onNav && onNav("product", product.id)}>
      <div style={{ position:"relative", width:"100%", aspectRatio:aspect.ratio, overflow:"hidden", background:"#111" }}>
        <video
          src={video.videoUrl}
          autoPlay muted={muted} loop playsInline
          style={{ width:"100%", height:"100%", objectFit:"contain" }}
        />
        <button onClick={e=>{ e.stopPropagation(); setMuted(m=>!m); }}
          style={{ position:"absolute", bottom:12, right:12, width:34, height:34, borderRadius:"50%", background:"rgba(0,0,0,0.5)", border:"none", color:"white", fontSize:14, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>
          {muted ? "🔇" : "🔊"}
        </button>
      </div>

      {product && (
        <div style={{ padding:"12px 12px 14px" }}>
          <div style={{ fontSize:12.5, fontWeight:700, color:"#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:6 }}>{product.name}</div>
          <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
            <span style={{ fontSize:15, fontWeight:900, color:"#EC4899" }}>₹{product.price?.toLocaleString("en-IN")}</span>
            {product.mrp > product.price && (
              <>
                <span style={{ fontSize:11.5, color:"#999", textDecoration:"line-through", fontWeight:500 }}>₹{product.mrp?.toLocaleString("en-IN")}</span>
                <span style={{ fontSize:10.5, fontWeight:800, color:"#16A34A", background:"#F0FDF4", padding:"2px 8px", borderRadius:20 }}>
                  {Math.round((1-product.price/product.mrp)*100)}% OFF
                </span>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
